import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { RootState } from "../../store/store";
import { findMembers } from "../../store/findMemberSearchResultSlice";
import { AsyncThunkAction, Dispatch, AnyAction } from "@reduxjs/toolkit";
import MemberServices from "../../services/MemberServices";
import { PageLink } from "../../components/StyledComp/StyledComp";
import PrintIcon from "../../Images/MenuIconComp/printIcon";
import IMember from "../../store//memberInterfaceStruct";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetSearchParameters } from "../../store/searchMemberApiSlice";
import { Alert } from "react-bootstrap";
import AlertWithModal from "../../components/utilityComponents/AlertWithModal";

// import { Container } from './styles';

const PrintMemberLabel: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [labelData, setLabelData] = useState<any[]>([]);
  const [hasSelectedMembers, setHasSelectedMembers] = useState<boolean>(false);
  const [isGetAllMembersLoading, setIsGetAllMembersLoading] =
    useState<boolean>(false);
  const searchParameters = useSelector(
    (state: RootState) => state.searchMemberApiSlice
  );
  const [allMembersFlag, setAllMembersFlag] = useState<boolean>(false);
  const findMemberListUpdated = useSelector(
    (state: RootState) => state.findMemberListUpdatedApiSlice
  );
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  useEffect(() => {
    const getMemberList = async () => {
      console.log("getAdminList called");
      const response = await MemberServices.getMemberLabels(searchParameters);
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success");
        console.log("response1...", response.data.data);
        setLabelData(response.data.data);
      } else {
        console.log("error", response);
      }
    };

    getMemberList();

    findMemberListUpdated.members.some((member: IMember) => {
      if (member.isChecked) {
        setHasSelectedMembers(true);
        return true;
      }
      return false;
    });
  }, []);

  useEffect(() => {
    if (allMembersFlag) {
      getAllMemberList();
    }
  }, [allMembersFlag]);

  const getAllMemberList = async () => {
    console.log("getAdminList called");
    setIsGetAllMembersLoading(true);
    const response = await MemberServices.getAllMemberLabels(searchParameters);
    console.log("response...", response.data.data);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      setIsGetAllMembersLoading(false);
      console.log("Success");
      console.log("response1...", response.data.data);
      setLabelData(response.data.data);
    } else {
      console.log("error", response);
    }
  };

  const componentRef = React.useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Member-data",
    onAfterPrint: () => alert("Request sent to printer"),
  });
  const inlineStyle = {
    color: "#254C65",
    fontSize: "13px",
    height: "120px",
    pageBreakInside: "avoid" as "auto" | "avoid",
  };
  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-content-wrapper">
        <div className="horizontal-wrapper-spacebetween">
          <h1 className="page-heading">
            Print label{" "}
            {allMembersFlag ? "(All Members)" : `(${labelData.length} Members)`}
          </h1>
          <div className="d-flex">
            <div
              className="secondary-button"
              onClick={() => {
                dispatch(resetSearchParameters());
                setAllMembersFlag(true);
                setHasSelectedMembers(false);
              }}
            >
              <span>Show Label For All Members</span>
            </div>
            <div className="secondary-button" onClick={handlePrint}>
              <PrintIcon height={20} width={20} />
              <span style={{ marginLeft: "5px" }}>Print</span>
            </div>
            <PageLink
              onClick={() => {
                setAllMembersFlag(false);
                navigate("/member/findmember", { replace: true });
              }}
              style={{ marginBottom: "1rem" }}
            >
              close
            </PageLink>
          </div>
          {/* <PageLink onClick={handlePrint}> Print this</PageLink> */}
        </div>

        {/* <button onClick={handlePrint}> Print this</button> */}
        <div className="printA4Sheet-div, container-fluid" ref={componentRef}>
          {isGetAllMembersLoading ? (
            <span>Loading...</span>
          ) : (
            <div>
              {hasSelectedMembers ? (
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {findMemberListUpdated.members.map((item, index) => {
                    return item.isChecked ? (
                      <div
                        className="col-sm-5 py-1 border"
                        key={index}
                        style={{
                          ...inlineStyle,
                          display: "flex", // Enables Flexbox
                          flexDirection: "column",
                          justifyContent: "flex-start", // Centers content horizontally
                          alignItems: "center", // Centers content vertically
                        }}
                      >
                        <div
                          style={{
                            textAlign: "left", // Aligns text to the left
                            width: "100%", // Ensures the inner div takes full width
                          }}
                        >
                          {item.Esquire && item.Esquire.includes("Hon")
                            ? "The Honorable"
                            : null}
                        </div>
                        <div
                          style={{
                            textAlign: "left", // Aligns text to the left
                            width: "100%", // Ensures the inner div takes full width
                          }}
                        >
                          {item.FirstName} {item.LastName}
                          {item.Esquire && item.Esquire.includes("Hon")
                            ? null
                            : ","}
                          {item.Esquire && item.Esquire.includes("Hon")
                            ? null
                            : " Esq."}
                        </div>
                        {item.PrimaryAddress &&
                        item.PrimaryAddress.FirmName &&
                        item.PrimaryAddress.FirmName ? (
                          <div
                            style={{
                              textAlign: "left", // Aligns text to the left
                              width: "100%", // Ensures the inner div takes full width
                            }}
                          >
                            {item.PrimaryAddress.FirmName}
                          </div>
                        ) : (
                          <></>
                        )}
                        <div
                          style={{
                            textAlign: "left", // Aligns text to the left
                            width: "100%", // Ensures the inner div takes full width
                          }}
                        >
                          {item.PrimaryAddress && item.PrimaryAddress.Address1}
                          {item.PrimaryAddress &&
                          item.PrimaryAddress.Address2 &&
                          item.PrimaryAddress.Address2
                            ? ", "
                            : null}
                          {item.PrimaryAddress && item.PrimaryAddress.Address2}
                        </div>
                        <div
                          style={{
                            textAlign: "left", // Aligns text to the left
                            width: "100%", // Ensures the inner div takes full width
                          }}
                        >
                          {item.PrimaryAddress && item.PrimaryAddress.City}{" "}
                          {item.PrimaryAddress && item.PrimaryAddress.State}{" "}
                          {item.PrimaryAddress && item.PrimaryAddress.Zipcode}
                        </div>

                        {/* <p className="m-0">
                      <span>
                        {item.FirstName}&nbsp;{item.LastName}
                      </span>
                    </p>
                    <p className="m-0">{item.FirmName}</p>
                    <p className="m-0">
                      {item.Address1}&nbsp; {item.Address2}
                    </p>
                    <p className="m-0">
                      {item.County}&nbsp; {item.State}&nbsp; {item.Zipcode}
                    </p> */}
                      </div>
                    ) : (
                      <></>
                    );
                  })}
                </div>
              ) : (
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {Array.isArray(labelData)
                    ? labelData.map((item, index) => {
                        return (
                          <div
                            className="col-sm-5 py-1 border"
                            key={index}
                            style={{
                              ...inlineStyle,
                              display: "flex", // Enables Flexbox
                              flexDirection: "column",
                              justifyContent: "flex-start", // Centers content horizontally
                              alignItems: "center", // Centers content vertically
                            }}
                          >
                            <div
                              style={{
                                textAlign: "left", // Aligns text to the left
                                width: "100%", // Ensures the inner div takes full width
                              }}
                            >
                              {item.Esquire && item.Esquire.includes("Hon")
                                ? "The Honorable"
                                : null}
                            </div>
                            <div
                              style={{
                                textAlign: "left", // Aligns text to the left
                                width: "100%", // Ensures the inner div takes full width
                              }}
                            >
                              {item.FirstName} {item.LastName}
                              {item.Esquire && item.Esquire.includes("Hon")
                                ? null
                                : ","}
                              {item.Esquire && item.Esquire.includes("Hon")
                                ? null
                                : " Esq."}
                            </div>
                            {item.FirmName && item.FirmName ? (
                              <div
                                style={{
                                  textAlign: "left", // Aligns text to the left
                                  width: "100%", // Ensures the inner div takes full width
                                }}
                              >
                                {item.FirmName}
                              </div>
                            ) : (
                              <></>
                            )}
                            <div
                              style={{
                                textAlign: "left", // Aligns text to the left
                                width: "100%", // Ensures the inner div takes full width
                              }}
                            >
                              {item.Address1}
                              {item.Address2 && item.Address2 ? ", " : null}
                              {item.Address2}
                            </div>
                            <div
                              style={{
                                textAlign: "left", // Aligns text to the left
                                width: "100%", // Ensures the inner div takes full width
                              }}
                            >
                              {item.City} {item.State} {item.Zipcode}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              )}{" "}
            </div>
          )}
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default PrintMemberLabel;
